import { HYROX_TRAININGEN } from "../../data/schemaDataHyrox";

export const API = process.env.REACT_APP_BACKEND_URL;

export const SPIERGROEPEN_LIB = ["Borst", "Rug", "Schouders", "Biceps", "Triceps", "Benen", "Hamstrings", "Billen", "Core", "Kuiten", "Full Body", "Anders"];
export const APPARATEN = ["Barbell", "Dumbbell", "Machine", "Kabel", "Bodyweight", "Anders"];
export const TYPES = ["Compound", "Isolatie"];

export const DOEL_LABELS = {
  vetverlies: "Vetverlies",
  spieropbouw: "Spieropbouw",
  onderhoud: "Onderhoud",
  powerlift: "Powerlifting",
  hyrox: "Hyrox Trainingen",
};

export const DOEL_COLORS = {
  vetverlies:  { bg: "bg-orange-500/15", text: "text-orange-400", border: "border-orange-500/25" },
  spieropbouw: { bg: "bg-blue-500/15",   text: "text-blue-400",   border: "border-blue-500/25" },
  onderhoud:   { bg: "bg-green-500/15",  text: "text-green-400",  border: "border-green-500/25" },
  powerlift:   { bg: "bg-purple-500/15", text: "text-purple-400", border: "border-purple-500/25" },
  hyrox:       { bg: "bg-cyan-500/15",   text: "text-cyan-400",   border: "border-cyan-500/25" },
};

export const HYROX_OPTIONS = HYROX_TRAININGEN.map(t => ({
  product: t.id,
  label: t.naam,
  doel: "hyrox",
}));

export const SCHEMA_OPTIONS = [
  ...["vetverlies", "spieropbouw", "onderhoud", "powerlift"].flatMap(doel =>
    ["beginner", "gevorderd", "advanced"].flatMap(niveau =>
      ["2x", "3x", "4x"].map(freq => ({
        product: `${doel}-${niveau}-${freq}`,
        label: `${DOEL_LABELS[doel]} ${niveau.charAt(0).toUpperCase() + niveau.slice(1)} \u2013 ${freq} per week`,
        doel,
      }))
    )
  ),
  ...HYROX_OPTIONS,
];
